import { render, staticRenderFns } from "./ModalWalletDeposit.vue?vue&type=template&id=0a5dba22&scoped=true"
import script from "./ModalWalletDeposit.vue?vue&type=script&lang=js"
export * from "./ModalWalletDeposit.vue?vue&type=script&lang=js"
import style0 from "./ModalWalletDeposit.vue?vue&type=style&index=0&id=0a5dba22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5dba22",
  null
  
)

export default component.exports